"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useExpansionPanelDetailsStyles = exports.useExpansionPanelSummaryStyles = exports.useExpansionPanelStyles = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      borderTop: "1px solid ".concat(theme.palette.neutral.stainless)
    }
  };
}, {
  name: 'PdsAccordion'
});

exports.default = _default;
var useExpansionPanelStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      borderBottom: "1px solid ".concat(theme.palette.neutral.stainless),
      '&::before': {
        height: 0
      },
      '&$expanded': {
        margin: 0
      },
      '&$disabled': {
        backgroundColor: 'white'
      }
    },
    expanded: {},
    disabled: {}
  };
}, {
  name: 'PdsExpansionPanel'
});
exports.useExpansionPanelStyles = useExpansionPanelStyles;
var useExpansionPanelSummaryStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      boxSizing: 'border-box',
      minHeight: 'auto',
      padding: theme.spacing(2),
      '&:hover': {
        backgroundColor: theme.palette.sapphire[50]
      },
      '&:active': {
        backgroundColor: theme.palette.sapphire[50]
      },
      '&$focused': {
        backgroundColor: theme.palette.sapphire[50]
      },
      '&$expanded': {
        minHeight: 'auto'
      },
      '&$expanded $content': {
        margin: 0,
        marginRight: theme.spacing(2)
      },
      '&$disabled': {
        opacity: 1
      },
      '&$disabled $expandIcon': {
        color: theme.palette.neutral.mono
      }
    },
    expanded: {},
    focused: {},
    disabled: {
      backgroundColor: theme.palette.neutral.iceberg,
      '& $content': {
        color: theme.palette.neutral.spoon
      }
    },
    content: _objectSpread(_objectSpread({}, theme.typography.body), {}, {
      alignItems: 'center',
      color: theme.palette.denim[500],
      fontFamily: theme.typography.fontFamilyBold,
      margin: 0,
      marginRight: theme.spacing(2)
    }),
    expandIcon: {
      color: theme.palette.denim[500],
      margin: 0,
      padding: 0,
      '&$expanded': {
        transform: 'rotate(-180deg)'
      }
    },
    icon: {
      alignItems: 'center',
      color: 'inherit',
      display: 'inline-flex',
      height: 24,
      justifyContent: 'center',
      lineHeight: 0,
      marginRight: theme.spacing(2),
      width: 24
    }
  };
}, {
  name: 'PdsExpansionPanelHeader'
});
exports.useExpansionPanelSummaryStyles = useExpansionPanelSummaryStyles;
var useExpansionPanelDetailsStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: _objectSpread(_objectSpread({}, theme.typography.body), {}, {
      color: theme.palette.denim[500],
      padding: theme.spacing(2)
    })
  };
}, {
  name: 'PdsExpansionPanelDetails'
});
exports.useExpansionPanelDetailsStyles = useExpansionPanelDetailsStyles;
